import React from "react";
import {useIndexRoving} from "@hooks/useIndexRoving";

const ButtonsGroup = props => {
    const {className, role = 'group', position = '', children, ...other} = props;
    const positionClass = position.toLowerCase() === 'right' ? ' ch-buttons-group-right' : '';
    const {ref, onKeyDown, onFocus, onClick} = useIndexRoving();
    return (
        <div ref={ref} onKeyDown={onKeyDown} onFocus={onFocus} onClick={onClick} role={role} className={"ch-buttons-group" + positionClass + (className ? ' ' + className : '')} {...other}>{children}</div>
    )
}

export default ButtonsGroup;